// extracted by mini-css-extract-plugin
export default {"wrapper":"Verify_wrapper__1bq9q"};